<template>
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
  >
    <path d="M3.49664 0H16.9966C18.7297 0 20.1459 1.35645 20.2415 3.06558L20.2466 3.25V12.75C20.2466 14.483 18.8902 15.8992 17.1811 15.9949L16.9966 16H3.49664C1.76361 16 0.347397 14.6435 0.251788 12.9344L0.246643 12.75V3.25C0.246643 1.51697 1.6031 0.100754 3.31222 0.0051446L3.49664 0H16.9966H3.49664ZM18.7466 5.373L10.596 9.66369C10.4085 9.76233 10.1898 9.77642 9.99341 9.70596L9.89733 9.66369L1.74664 5.374V12.75C1.74664 13.6682 2.45375 14.4212 3.35312 14.4942L3.49664 14.5H16.9966C17.9148 14.5 18.6678 13.7929 18.7408 12.8935L18.7466 12.75V5.373ZM16.9966 1.5H3.49664C2.57847 1.5 1.82545 2.20711 1.75244 3.10647L1.74664 3.25V3.679L10.2466 8.15246L18.7466 3.678V3.25C18.7466 2.33183 18.0395 1.57881 17.1402 1.5058L16.9966 1.5Z" />
  </svg>
</template>
